import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { UtilService } from '../service/util.service';
import { Constants } from '../constants/constants';
import { NgForm } from '@angular/forms';
import { ApiService } from '../service/api.service';
import { ToastService } from '../service/toast.service';
import { AuthenticationService } from '../service/authentication.service';
import { AccountDetail } from '../shared/model/account-detail.model';
import { ContactEmail } from '../shared/model/contact-email.model';
import { ContactAddress } from '../shared/model/contact-address.model';
import { ContactPoint } from '../shared/model/contact-point.model';
import { ContactPhone } from '../shared/model/contact-phone.model';
import { EnvService } from '../service/env.service';
import { Observable } from 'rxjs/internal/Observable';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { map } from 'rxjs/internal/operators/map';

@Component({
  selector: 'app-account-update',
  templateUrl: './account-update.component.html',
  styleUrls: ['./account-update.component.scss']
})
export class AccountUpdateComponent implements OnInit {

  account: any;
  updateAccModal: AccountDetail;
  invalidZipCode: boolean = false;
  stateList: Array<any> = new Array();
  @Output() updateEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelUpdateEmitter: EventEmitter<any> = new EventEmitter<any>();
  
  isd = "";
  updateAccPayload;

  countryList: Array<any> = new Array();
  selectedIsdDetails: any;
  isdFormatter = (x: { isd: string }) => x.isd;
  searchIsd = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => term === '' ? [] : this.countryList.filter(v => (v.name.toLowerCase().indexOf(term.toLowerCase()) > -1 || v.isd.toLowerCase().indexOf(term.toLowerCase()) > -1)))
    );   
  phoneLength = 10;  

  constructor(private utilService: UtilService, private router: Router, private authService: AuthenticationService, private apiService: ApiService, private toastService: ToastService, private env: EnvService) { 
    this.countryList = this.utilService.getCountryList(this.env.REGION);
  }

  ngOnInit() {
    this.account = this.apiService.accountDetail;
    console.log("Account Data : ", this.account);
    
    let accountCountry = this.account.contactPoints.addresses[0].country;
    let selectedCountryData = this.countryList.filter(countryObject =>countryObject.name == accountCountry)[0];

    if (selectedCountryData) {
      this.getStateList(selectedCountryData.isotwo);
    }

    this.initAccModal();
  }

  initAccModal() {
    let contactPoints;
    if (this.account.contactPoints) {

      let address;
      let email;
      let phone;

      if (this.account.contactPoints.addresses && this.account.contactPoints.addresses.length > 0) {

        address = new ContactAddress(this.account.contactPoints.addresses[0].street,
          this.account.contactPoints.addresses[0].postalCode,
          this.account.contactPoints.addresses[0].state,
          this.account.contactPoints.addresses[0].city,
          this.account.contactPoints.addresses[0].country,
          this.account.contactPoints.addresses[0].plus4Code,
          );
      }

      if (this.account.contactPoints.emails && this.account.contactPoints.emails.length > 0) {
        email = new ContactEmail(this.account.contactPoints.emails[0].category,
          this.account.contactPoints.emails[0].name,
          this.account.contactPoints.emails[0].type,
          this.account.contactPoints.emails[0].value);
      } else {
        email = new ContactEmail(null, null, null, null);
      }

      if (this.account.contactPoints.phones && this.account.contactPoints.phones.length > 0) {

        // TODO: handle for multiple ISDs 
        if (this.account.contactPoints.phones[0].value) {
          var isdPhone = this.utilService.splitIsdAndPhone(this.account.contactPoints.phones[0].value);
          console.log("isdPhone :: ", isdPhone);
          this.account.contactPoints.phones[0].value = isdPhone.phone;
          console.log("Account contact points :: ", this.account.contactPoints);
        }

        phone = new ContactPhone(this.account.contactPoints.phones[0].category,
          this.account.contactPoints.phones[0].name, this.account.contactPoints.phones[0].type,
          this.account.contactPoints.phones[0].value, this.account.contactPoints.phones[0].isd);
        this.isd = this.account.contactPoints.phones[0].isd ? this.account.contactPoints.phones[0].isd : Constants.DEFAULT_ISD;
        
        console.log("isd: ", this.isd);
        console.log("countrylist: ", this.countryList);
        
        this.selectedIsdDetails = this.countryList.filter(countryObject =>countryObject.isd == this.isd)[0];
        console.log("selectedisddetails: ", this.selectedIsdDetails);
      } else {
        phone = new ContactPhone(null, null, null, null, null);
      }
      contactPoints = new ContactPoint(address, email, phone);
    }

    this.updateAccModal = new AccountDetail(this.account.name,
      this.account.oemCustomerId,
      this.account.customerCategory,
      this.account.type,
      this.account.logo,
      contactPoints);

    console.log("Update account  model : ", this.updateAccModal);


    let accountCountry = this.account.contactPoints.addresses[0].country;
    if (accountCountry) {
      this.updateIsd(accountCountry);
    }
  }

  resetUpdateAccForm() {
    this.initAccModal();
    this.cancelUpdateEmitter.emit();
  }

  updateAccFormSubmit(form: NgForm) {
    if (form.valid) {
      console.log("Update acc form submit : ", this.updateAccModal);

      this.updateAccPayload = this.getUpdateAccModalPayload();
      this.updateAccountDetail();
    }
  }

  updateAccountDetail() {
    this.utilService.showSpinner();
    this.apiService.updateAccountDetail(this.updateAccPayload).then((data) => {
      this.utilService.hideSpinner();
      this.toastService.showSuccess("Account updated successfully");
      this.updateAccountData(data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.updateAccountDetail();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  updateDeviceProviderAccount() {
    this.utilService.showSpinner();
    this.apiService.updateDeviceProviderAccount(this.updateAccPayload).then((data) => {
      this.utilService.hideSpinner();
      this.toastService.showSuccess("Account updated successfully");
      this.updateAccountData(data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.updateDeviceProviderAccount();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  updateAccountData(data) {
    this.apiService.accountDetail.name = data.name;
    this.apiService.accountDetail.contactPoints = data.contactPoints;
    this.apiService.accountDetail.logo = data.logo;
    this.account = this.apiService.accountDetail;
    this.initAccModal();
    this.updateEmitter.emit();
  }

  changeuploadFleetLogoClicked() {
    console.log("open file picker");
    document.getElementById("uploadLogoInput").click();
  }

  uploadFleetLogo(event) {
    console.log("Upload fleet logo event : ", event);

    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      var extn =  file.name.split('.').pop();
      console.log("extn : ", extn);
      if (!Constants.ALLOWED_IMAGE_TYPE.includes(extn.toLowerCase())) {
        this.toastService.showError(Constants.IMAGE_UPLOAD_FILE_TYPE_ERROR_MESSAGE);
        return;
      }
      var fileSizeInKB = file.size / 1024;
      console.log("actual file size : ", file.size, " - fileSizeInKB : ", fileSizeInKB, " - max file size limit in kb : ", Constants.IMAGE_UPLOAD_MAX_SIZE_KB);
      if (fileSizeInKB > Constants.IMAGE_UPLOAD_MAX_SIZE_KB) {
        this.toastService.showError(Constants.IMAGE_UPLOAD_FILE_SIZE_ERROR_MESSAGE);
        return;
      }
      let formData: FormData = new FormData();
      formData.append('file', file, file.name);

      this.utilService.showSpinner();
      this.apiService.uploadFleetLogo(formData).then((data) => {
        this.utilService.hideSpinner();
        console.log("Response is :: ", data);
        this.updateAccModal.logo = data.imageUrl;
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_UNAUTHORISED) {
          this.authService.refreshToken().then(() => {
            this.utilService.hideSpinner();
            console.log("refresh token api executed");
            this.uploadFleetLogo(event);
          });
        }
        else {
          this.utilService.hideSpinner();
          if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
          else this.toastService.showError(Constants.UNKNOWN_ERROR);
        }
      });
    }
  }

  getZipCodeDetails(zipCode) {
    if (zipCode.length == 5) {
      this.apiService.getZipCodeDetails(zipCode).then((data) => {
        console.log("zip code detail data from api : ", data);
        this.invalidZipCode = false;
        this.updateAccModal.contactPoints.addresses[0].state = data.places[0]["state abbreviation"];
        this.updateAccModal.contactPoints.addresses[0].city = data.places[0]["place name"];
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_NOT_FOUND) {
          this.invalidZipCode = true;
        } else if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
      });
    } else {
      this.invalidZipCode = false;
      this.updateAccModal.contactPoints.addresses[0].state = null;
      this.updateAccModal.contactPoints.addresses[0].city = null;
    }
  }

  getUpdateAccModalPayload() {
    let payload = JSON.parse(JSON.stringify(this.updateAccModal));
    payload.regionType =  this.account.regionType ? this.account.regionType : Constants.DEFAULT_REGION_TYPE;

    if (![null, ""].includes(payload.contactPoints.phones[0].value)) {
      payload.contactPoints.phones[0].value = payload.contactPoints.phones[0].value;
      payload.contactPoints.phones[0].isd = this.isd;
    }
    
    return payload;
  }

  onCountrySelected(selectedCountry) {
    this.resetCountryDependentFields();

    let selectedCountryData = this.countryList.filter(countryObject => countryObject.name == selectedCountry)[0];
    if (selectedCountryData) {
      this.getStateList(selectedCountryData.isotwo);
    }
    if (!(this.updateAccModal.contactPoints && this.updateAccModal.contactPoints.phones && this.updateAccModal.contactPoints.phones[0].value)) {
      this.updateIsd(selectedCountry);
    }

  }
  
  updateIsd(selectedCountry) {
    let selectedCountryData = this.countryList.filter(country => country.name == selectedCountry)[0];

    if (selectedCountryData) {
      // this.selectedIsdDetails = selectedCountryData;
      this.onIsdSelected(selectedCountryData);
    }
  }

  onIsdSelected(event) {
    console.log("event: ", event);
    if (event.phoneLength) {
      this.phoneLength = event.phoneLength;
    }
    this.isd = event.isd;
  }

  getStateList(countryCode) {
    this.utilService.showSpinner();
    this.apiService.getStateList(countryCode).then((data) => {
      this.utilService.hideSpinner();
      this.stateList = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getStateList(countryCode);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });

  }  

  resetCountryDependentFields() {
    this.updateAccModal.contactPoints.addresses[0].postalCode = null;
    this.updateAccModal.contactPoints.addresses[0].city = null;
    this.updateAccModal.contactPoints.addresses[0].state = null;
    this.stateList = null;
  }

  resetStateDependentFields() {
    this.updateAccModal.contactPoints.addresses[0].city = null;
    this.updateAccModal.contactPoints.addresses[0].postalCode = null;
  }  

  stateSelected(state) {
    console.log("Selected State : ", state);
    this.resetStateDependentFields();
  }  
}
